// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { FunctionsUtilsService } from '../../../../../core/_base/crud/utils/functions-utils.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
	selector: 'kt-delete-entity-dialog',
	templateUrl: './logout-dialog.component.html',
	styleUrls: ['logout-dialog.component.scss']
})
export class LogoutDialogComponent implements OnInit {
	// Public properties
	viewLoading: boolean = false;
    form : FormGroup;
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<LogoutDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private translate: TranslateService,
		private fb: FormBuilder,
		public functionsUtilsService:FunctionsUtilsService
	) { }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.dialogRef.updateSize(`25pc`, `17pc`);
		this.initForm();
	}

	initForm(){
	    this.form = this.fb.group({
			amount: ['',Validators.compose([Validators.required,Validators.min(0)])]
		})
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.dialogRef.close(this.form.getRawValue()); // Keep only this row
	}

	isControlHasError(form:FormGroup,controlName: string, validationType: string): boolean {
		if(!form){
			return false;
		}
		const control = form.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

}
